/* eslint-disable no-undef */
export default {
	name: "link-products-to-customer-depot-discount-group-modal",
	props: ["heading", "modalId", "showModal", "customerDiscountGroupId", "depotId", "discountAmount", "unlinkedProductId"],
	emits: ["okClicked", "onProductsLinkedOrUnlinked"],
	data() {
		return {
			customerDiscountGroupProducts: [],
			products: [],
			customerDiscountGroup:{},
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			productSearchQuery: null,
			productsToLink: [],
			productsToUnlink: [],
			hasSearched: false,
			newProductIdsToLink: []
		};
	},
	methods: {
		getProducts() {
			this.loading = true;
			let request = {
				allowCollection: true,
				allowDelivery: false,
				isActive: true
			};
			productService.getProducts(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						this.getCustomerDiscountGroupProducts();
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerDiscountGroupProducts() {
			if(this.depotId === null){
				return;
			}
			this.loading = true;
			this.showErrorMessage = false;
			var customerDiscountGroupId = this.customerDiscountGroupId === null ? 0 : this.customerDiscountGroupId;
			orderService.getProductsForDepotDiscountGroup(customerDiscountGroupId, this.depotId, this.productSearchQuery).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						console.log("Response", successResponse.data.result);
						this.customerDiscountGroupProducts = successResponse.data.result;
						// for(var i = 0; i < this.products.length; i++){
						// 	this.products[i].discountAmount = this.customerDiscountGroup.discountAmount;
						// 	//this.products[i].discountedPrice = this.products[i].price - this.products[i].discountAmount;
						// 	// if(this.products[i].discountedPrice < 0){
						// 	// 	this.products[i].discountedPrice = 0;
						// 	// }
						// 	//this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].price);
						// 	//this.products[i].discountedPriceAsString = currencyHelper.numberToCurrency(this.products[i].discountedPrice);
						// 	//this.products[i].discountAmountAsString = currencyHelper.numberToCurrency(this.products[i].discountAmount);
						// 	for(var j = 0; j < this.customerDiscountGroupProducts.length; j++){
						// 		this.products[i].isSelected = this.products[i].productId === this.customerDiscountGroupProducts[j].productId;
						// 	}
						// }
						if(this.customerDiscountGroupProducts !== null){
							for(let i = 0; i < this.customerDiscountGroupProducts.length; i++) {
								this.customerDiscountGroupProducts[i].isSelected = this.customerDiscountGroupProducts[i].isLinkedToDepotDiscountGroup;
								this.customerDiscountGroupProducts[i].discountAmountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroupProducts[i].discountAmount);
								this.customerDiscountGroupProducts[i].priceAsString = currencyHelper.numberToCurrency(this.customerDiscountGroupProducts[i].price);
								this.customerDiscountGroupProducts[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.customerDiscountGroupProducts[i].priceAfterDiscount);
								if(this.hasSearched || this.productsToLink.length > 0){
									this.customerDiscountGroupProducts[i].isSelected = this.productsToLink.find(x => x.productId === this.customerDiscountGroupProducts[i].productId) !== undefined;
								}
							}
						}
						this.onModalSaveClick(false);
						if(this.customerDiscountGroupProducts == null || this.customerDiscountGroupProducts.length === 0){
							this.showErrorMessage = true;
							this.errorMessage = "No Products Found. Please ensure that you have added pricing for the selected depot. Navigate to Pricing > Collection > Depot Pricing Per Product to Add Pricing.";
						}
						console.log("customerDiscountGroupProducts", this.customerDiscountGroupProducts);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClick(){
			this.hasSearched = true;
			this.getCustomerDiscountGroupProducts();
		},
		getCustomerDiscountGroup(){
			
			this.customerDiscountGroup = {
				customerDiscountGroupId: 1,
				discountAmount: 0.02,
				isActive: true,
				name: "Pump Less Than 2 Cents"
			};
			this.getProducts();
		},
		clearMessageAlerts(){
			// this.showErrorMessage = false;
			// this.errorMessage = null;
			//
			// this.showSuccessMessage = false;
			// this.successMessage = null;

			this.$emit("okClicked", true);
		},
		onProductSelectOrUnselect(product){
			if(product.isSelected){
				this.productsToLink.push(product);
				this.newProductIdsToLink.push(product.productId);
				this.productsToUnlink = this.productsToUnlink.filter(x => x.productId !== product.productId);
			}
			else{
				this.productsToLink = this.productsToLink.filter(x => x.productId !== product.productId);
				this.productsToUnlink.push(product);
				this.newProductIdsToLink = this.newProductIdsToLink.filter(x => x !== product.productId);
			}
		},
		onModalCloseClick() {
			this.productSearchQuery = null;
			this.hasSearched = false;
			for(let i = 0; i < this.customerDiscountGroupProducts.length; i++) {
				for (let j = 0; j < this.newProductIdsToLink.length; j++) {
					if (this.customerDiscountGroupProducts[i].productId === this.newProductIdsToLink[j]) {
						this.customerDiscountGroupProducts[i].isSelected = false;
						this.productsToLink = this.productsToLink.filter(x => x.productId !== this.newProductIdsToLink[j]);
						if (this.productsToUnlink.find(x => x.productId === this.newProductIdsToLink[j]) === undefined) {
							this.productsToUnlink.push(this.customerDiscountGroupProducts[i]);
						}
					}
				}
			}
			this.getCustomerDiscountGroupProducts();
			this.$emit("okClicked", true);
		},
		onModalSaveClick(isSaving = true){
			//save changes
			// this.loading = true;
			// this.showErrorMessage = false;
			// this.errorMessage = null;
			//
			// this.showSuccessMessage = false;
			// this.successMessage = null;
			this.newProductIdsToLink = [];
			if(this.productsToLink.length === 0 || this.productsToUnlink.length === 0) {
				var productIdsToLink = [];
				var productIdsToUnlink = [];
				console.log("customerDiscountGroupProducts", this.customerDiscountGroupProducts);
				for (var i = 0; i < this.customerDiscountGroupProducts.length; i++) {
					if (this.customerDiscountGroupProducts[i].isSelected) {
						productIdsToLink.push(this.customerDiscountGroupProducts[i]);
					}
					if (!this.customerDiscountGroupProducts[i].isSelected) {
						productIdsToUnlink.push(this.customerDiscountGroupProducts[i]);
					}
				}
				this.productsToLink.push(...productIdsToLink);
				this.productsToUnlink.push(...productIdsToUnlink);
				let request = {
					depotDiscountGroupId: this.customerDiscountGroupId,
					productIdsToLink: productIdsToLink,
					productIdsToUnlink: productIdsToUnlink,
					isSaving: isSaving
				};
				this.$emit("onProductsLinkedOrUnlinked", request);
			}
			else{
				this.$emit("onProductsLinkedOrUnlinked", {
					depotDiscountGroupId: this.customerDiscountGroupId,
					productIdsToLink: this.productsToLink,
					productIdsToUnlink: this.productsToUnlink,
					isSaving: isSaving
				});
			}

			if(isSaving){
				this.hasSearched = false;
				this.productSearchQuery = null;
				this.getCustomerDiscountGroupProducts();
			}
			// orderService.linkAndUnlinkProductsFromDepotDiscountGroup(request).then(
			// 	successResponse => {
			// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
			// 		if(isSuccess){
			// 			this.showSuccessMessage = true;
			// 			this.successMessage = "Products Linked to Customer Depot Discount Group Successfully.";
			// 			// this.$emit("completedPasswordReset", true);
			// 		}
			// 		this.loading = false;
			// 	},
			// 	errorResponse => {
			// 		console.log("error", errorResponse);
			// 		this.loading = false;
			// 		apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
			// 	}
			// );
		}
	},
	mounted: function () {
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalId).modal("show");
				}
				else{
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		},
		customerDiscountGroupId:{
			handler: function () {
				//this.getCustomerDiscountGroup();
				console.log("customerDiscountGroupId", this.customerDiscountGroupId);
				if(this.customerDiscountGroupId !== null && this.customerDiscountGroupId > 0){
					this.getCustomerDiscountGroupProducts();
				}
			},
			immediate: true,
			deep: true
		},
		discountAmount:{
			handler: function () {
				if(this.discountAmount !== null && this.discountAmount !== undefined){
					for(let i = 0; i < this.customerDiscountGroupProducts.length; i++){
						this.customerDiscountGroupProducts[i].discountAmount = this.discountAmount;
						this.customerDiscountGroupProducts[i].discountAmountAsString = currencyHelper.numberToCurrency(this.discountAmount);
					}
				}
			},
			immediate: true,
			deep: true
		},
		unlinkedProductId:{
			handler: function () {
				if(this.unlinkedProductId !== null && this.unlinkedProductId !== undefined){
					let product = this.customerDiscountGroupProducts.find(product => product.productId === this.unlinkedProductId);
					product.isSelected = false;
					this.productsToLink = this.productsToLink.filter(x => x.productId !== this.unlinkedProductId);
					if(this.productsToUnlink.find(x => x.productId === this.unlinkedProductId) === undefined){
						this.productsToUnlink.push(product);
					}
				}
			},
			immediate: true,
			deep: true
		},
		depotId:{
			handler: function () {
				console.log("depotId", this.depotId);
				this.showErrorMessage = false;
				this.errorMessage = null;

				this.showSuccessMessage = false;
				this.successMessage = null;
				if(this.depotId !== null && this.depotId > 0){
					this.newProductIdsToLink = [];
					this.productsToLink = [];
					this.productsToUnlink = [];
					this.getCustomerDiscountGroupProducts();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
